export const TOURIST_ROUTE_NAMES = {
    TOURIST: 'tourist',
    TOURIST_AI_LS: 'tourist-ai-ls',
    TOURIST_AI_LS_AGENT_DETAIL: 'tourist-ai-ls-agent-detail',
    TOURIST_AI: 'tourist-ai',
    TOURIST_AI_AGENT_FLOW: 'tourist-ai-agent-flow',
} as const;
